
import { i18n } from '@/plugins/i18n';
import { store } from '@/store';
import { UserState } from '@/store/user';
import * as PleasedApi from '@/common/api/api.pleased';
import { Country } from '@/common/config';

const ENABLE_CHECKS = true;

interface ApiCheck {
  id: string;
  slots: () => {
      message: string;
      actionMessage: string;
      warning: string;
      commonWarning: string;
  };
  check: () => Promise<boolean>;
}
const KYC: ApiCheck = {
  id: 'KYC',
  slots: () => ({
    message: i18n.t('chat.v2.check.kyc.message') as string,
    actionMessage: i18n.t('chat.v2.check.kyc.action_message') as string,
    warning: i18n.t('chat.v2.check.kyc.warning') as string,
    commonWarning: i18n.t('chat.v2.check.kyc.common_warning') as string,
  }),
  check: async () => {
    if (!ENABLE_CHECKS) return true;

    // TODO: Find a better way to inject user data.
    const vuexState = store.state as { user: UserState };
    console.log('Checking KYC', { userCountry: vuexState.user.country });

    if (!vuexState.user.country || !vuexState.user.token) {
      console.error('KYC check failed: user country or token not available');
      return true;
    }

    // Check KYC enabled brands.
    if (!([Country.INT, Country.NG, Country.GH, Country.UG] as string[]).includes(vuexState.user.country)) {
      // if this is not one of those countries, the check is not required.
      // This is ideally not required as only brands having KYC should configure this.
      // console.log('Skipping check', { xt: vuexState.user.country });
      return true;
    }

    return PleasedApi.checkKycCompleted({ countryCode: vuexState.user.country, sportyToken: vuexState.user.token }).catch(() => true);
  },
};

export const CHECKS = {
  KYC,
};
